import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

interface Props {
  title: string | null
}

const CompanyTitleContrast = ({title}: Props) => (
  <Typography
    sx={{textAlign: 'center'}}
    variant="h4"
    component="h2"
    gutterBottom
  >
    NC
    <Box component="span" sx={{color: 'primary.main'}}>
      FX
    </Box>{' '}
    {title}
  </Typography>
)

export default CompanyTitleContrast
